export const BIKE_TRIGGER_HISTORY_LOADING = "BIKE_TRIGGER_HISTORY_LOADING";
export const BIKE_TRIGGER_HISTORY_ERROR = "BIKE_TRIGGER_HISTORY_ERROR";

export const BIKE_TRIGGER_HISTORY_DELETE = "BIKE_TRIGGER_HISTORY_DELETE";
export const BIKE_TRIGGER_HISTORY_SEARCH = "BIKE_TRIGGER_HISTORY_SEARCH";



// WEBPACK FOOTER //
// ./src/actions/bike-trigger-history/constants.js